<template>
  <DBox :id="'cmp-distribution_account_sidewindow_setup'" :addButton="false">
    <div class="ut-fc">
      <Checkbox2
        style="flex:1"
        :disabled="false"
        :id="'main_account'"
        :label="$dft.capHead($t('main_account'))"
        :checked="selectedAccountsDetails.account.main_account==1"
        :value="selectedAccountsDetails.account.main_account"
        :placeholder="$dft.capHead($t('main_account'))"
        :lw="'135px'"
        @input="onCheckboxChange"
      />

      <Checkbox2
        style="flex:1"
        :disabled="false"
        :id="'dispatcher'"
        :label="$dft.capHead($t('dispatcher'))"
        :checked="selectedAccountsDetails.account.dispatcher==1"
        :value="selectedAccountsDetails.account.dispatcher"
        :placeholder="$dft.capHead($t('dispatcher'))"
        :lw="'135px'"
        @input="onCheckboxChange"
      />

      <Checkbox2
        style="flex:1"
        :disabled="false"
        :id="'own_stock'"
        :label="$dft.capHead($t('own_stock'))"
        :checked="selectedAccountsDetails.account.own_stock==1"
        :value="selectedAccountsDetails.account.own_stock"
        :placeholder="$dft.capHead($t('own_stock'))"
        :lw="'135px'"
        @input="onCheckboxChange"
      />

      <Checkbox2
        style="flex:1"
        :disabled="false"
        :id="'no_backorder'"
        :label="$dft.capHead($t('no_backorders'))"
        :checked="selectedAccountsDetails.account.no_backorder==1"
        :value="selectedAccountsDetails.account.no_backorder"
        :placeholder="$dft.capHead($t('no_backorders'))"
        :lw="'135px'"
        @input="onCheckboxChange"
      />
      <Checkbox2
        style="flex:1"
        :disabled="false"
        :id="'ignore_payment_period'"
        :label="$dft.capHead($t('ignore_payment_period'))"
        :checked="selectedAccountsDetails.account.ignore_payment_period==1"
        :value="selectedAccountsDetails.account.ignore_payment_period"
        :placeholder="$dft.capHead($t('ignore_payment_period'))"
        :lw="'135px'"
        @input="onCheckboxChange"
      />
      <Checkbox2
        style="flex:1"
        :disabled="false"
        :id="'mechanicals_omit'"
        :label="$dft.capHead($t('mechanicals_omit'))"
        :checked="selectedAccountsDetails.account.mechanicals_omit==1"
        :value="selectedAccountsDetails.account.mechanicals_omit"
        :placeholder="$dft.capHead($t('mechanicals_omit'))"
        :lw="'135px'"
        @input="onCheckboxChange"
        :bb="'none'"
      />
      
    </div>
  </DBox>
</template>
<script>
import { createTV, tv } from "../../../../models/text-value.model";

export default {
  props: {
    selectedAccountsDetails: {
      type: Object,
    },
  },

  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },
    };
  },
  methods: {
    onCheckboxChange: function ({ name, value }) {
      this.$emit("changed", {
        name,
        value: value ? "1" : "0",
      });
    },
  },
};
</script>
<style lang="scss">
.cmp-licencing-licence-accounts-sidewindow-account_setup {
  .flex-container {
    display: flex;
    padding: 10px;
    .flex-item {
      flex: 0.25;
      padding: 10px;
    }
  }
}
</style>
